import BounceOut from './bounce-out'
import BounceOutUp from './bounce-out-up'
import BounceOutLeft from './bounce-out-left'
import BounceOutDown from './bounce-out-down'
import BounceOutRight from './bounce-out-right'

export default {
  BounceOut,
  BounceOutUp,
  BounceOutLeft,
  BounceOutDown,
  BounceOutRight
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/bouncing-exits/index.js